export const ru = {
  // Navigation
  nav: {
    designers: 'Дизайнеры',
    selections: 'Подборки',
    blog: 'Блог',
    store: 'Магазин',
    about: 'О нас',
    basket: 'Корзина',
    menu: 'МЕНЮ',
  },

  // Sections
  sections: {
    designers: 'ДИЗАЙНЕРЫ',
    selections: 'ПОДБОРКИ',
    blog: 'БЛОГ',
    store: 'МАГАЗИН',
  },

  // Footer
  footer: {
    allRightsReserved: 'ВСЕ ПРАВА ЗАЩИЩЕНЫ',
    becomeMember: 'СТАТЬ УЧАСТНИКОМ',
    termsConditions: 'УСЛОВИЯ ИСПОЛЬЗОВАНИЯ',
    shippingReturns: 'ДОСТАВКА И ВОЗВРАТ',
    cookiePolicy: 'ПОЛИТИКА COOKIE',
  },
} as const

export type LocaleKeys = typeof ru
